import { FC } from 'react';

import { useScreenSize, VestingTaskHooks } from '../../../hooks/index';
import { AutomaticVestingTable } from './automatic-vesting-table';
import { VestingPlanType, vestingSharePlanType } from './table-variant';
import { VESTING_GRAPH_FULL_CHART_MIN_WIDTH_PX, VestingGraphCard } from './vesting-graph/index';

export type AutomaticVestingProps = {
  companyId: string;
  disableExercise: boolean;
  queriesEnabled: boolean;
  stakeholderId: string;
};

export const AutomaticVesting: FC<AutomaticVestingProps> = ({
  companyId,
  disableExercise,
  queriesEnabled,
  stakeholderId,
}) => {
  const { width } = useScreenSize();
  const showFullGraphs = width >= VESTING_GRAPH_FULL_CHART_MIN_WIDTH_PX;
  const {
    invalidateQuery,
    isError: isTasksError,
    vestingTasks,
  } = VestingTaskHooks.useVestingTasks({
    companyId,
    enabled: queriesEnabled,
    exercisable: null,
    stakeholderId,
  });

  return (
    <>
      {Object.values(VestingPlanType).flatMap((vestingType) =>
        vestingSharePlanType[vestingType].map((sharePlanType) => (
          <AutomaticVestingTable
            companyId={companyId}
            disableExercise={disableExercise}
            invalidateQuery={invalidateQuery}
            key={`${vestingType}_${sharePlanType}`}
            queriesEnabled={queriesEnabled}
            sharePlanType={sharePlanType}
            stakeholderId={stakeholderId}
            vestingTasks={vestingTasks}
            vestingType={vestingType}
          />
        )),
      )}

      {showFullGraphs && (
        <VestingGraphCard
          companyId={companyId}
          enabled={queriesEnabled}
          isTasksError={isTasksError}
          stakeholderId={stakeholderId}
          vestingTasks={vestingTasks}
        />
      )}
    </>
  );
};
